<template>
  <div id="top" class="out">
    <div>
      <!--container-->
      <div class="bigWrp">
        <div class="swiper-wrap">
          <swiper ref="mySwiper" :options="swiperOption">
            <swiper-slide v-for="(item, index) in item.imgLst" :key="index">
              <div
                :style="{ backgroundImage: 'url(' + item + ')' }"
                class="img"
                @click="shwImg"
              >
                <img :src="item" style="opacity:0;width:100%;height:100%" />
              </div>
            </swiper-slide>
            <div
              slot="button-prev"
              class="swiper-button-prev"
              @click.prevent
            ></div>
            <div
              slot="button-next"
              class="swiper-button-next"
              @click.prevent
            ></div>
          </swiper>
          <div class="c-wrap">
            <div class="camera" @click="shwImg">
              {{ initialSlide }}
              /
              <span v-if="item.imgLst && item.imgLst.length > 0">{{
                item.imgLst.length
              }}</span>
            </div>
          </div>
        </div>
        <div class="con" style="position:absolute">
          <div class="shadow"></div>
        </div>
        <div class="con">
          <div class="shadow"></div>
          <div class="txtWrp">
            <h1>
              ${{ item.price
              }}<span
                v-if="
                  item.maxPrice !== null &&
                    item.maxPrice !== '' &&
                    item.maxPrice !== '0' &&
                    item.maxPrice !== 0
                "
              >
                - ${{ item.maxPrice }}</span
              >
            </h1>
            <h2>{{ item.proertyType }}</h2>
            <h3>
              <i v-if="item.apt">{{ item.apt }} / </i>{{ item.address }}
              {{ item.suburb
              }}<span> {{ item.state }} {{ item.postcode }}</span>
            </h3>
            <div class="dtl" v-bind:class="'tenant-' + tenant">
              <p>
                <span>Estimated commencement</span
                ><span>{{ item.estimatedCommenceMent }}</span>
              </p>
              <p>
                <span>Estimated completion</span
                ><span>{{ item.estimatedCompletion }}</span>
              </p>
              <p>
                <span>Estimated rental<br />(per week)</span>
                <span style="margin-top:.05rem">
                  ${{ item.rental }}
                  <i
                    v-if="
                      item.maxRental &&
                        item.maxRental !== '' &&
                        item.maxRental !== 0 &&
                        item.maxRental !== '0'
                    "
                    style="font-style:normal;display:block;line-height:.2rem;float:none;text-align:left"
                  >
                    -
                  </i>
                  <i
                    v-if="
                      item.maxRental &&
                        item.maxRental !== '' &&
                        item.maxRental !== 0 &&
                        item.maxRental !== '0'
                    "
                    style="font-style:normal;display:block;float:none;text-align:left"
                    >${{ item.maxRental }}</i
                  >
                </span>
              </p>
              <p v-if="item.proertyType === 'House & Land'">
                <span>Land price</span><span>${{ item.landPrice }}</span>
              </p>
              <p v-if="item.proertyType === 'House & Land'">
                <span>Build price</span><span>${{ item.buildPrice }}</span>
              </p>
              <p>
                <span>Rental yield</span><span>{{ item.rentalYield }}%</span>
              </p>
              <p>
                <span>Incentives</span><span v-html="item.incentives"></span>
              </p>
            </div>
            <!--<transition name="btn">
                  <div class="commision clear" v-if="mode === 'off' && (curMode === 'off' || curMode === '')">
                      <h4 :class="{'huan': item.maxCommision!== null && item.maxCommision !== undefined && item.maxCommision !== '' && $route.params.roomId == 'room'}">Your commission (inc.GST)
                        <span>${{item.commision}}
                          <i style="font-style:normal"
                          v-if="item.maxCommision!== null && item.maxCommision !== undefined && item.maxCommision !== '' && item.maxCommision !== '0' && item.maxCommision !== 0"
                          > - ${{item.maxCommision}}</i>
                        </span>
                      </h4>
                      <h5>For payment terms please refer to your agreement or contact your UNIFI Representive</h5>
                  </div>
              </transition>-->
          </div>
        </div>
      </div>
      <div class="down-wrap">
        <div class="down">
          <a
            v-if="
              item.informationPack !== '' &&
                item.informationPack !== undefined &&
                item.informationPack !== null
            "
            :href="item.informationPack"
            download
            target="_blank"
            >Download property information pack</a
          >
          <a v-else @click="empty">Download property information pack</a>
        </div>
      </div>
      <div class="container">
        <h1 v-bind:class="'tenant-' + tenant">Description</h1>
        <p v-html="item.description"></p>
        <h1 v-bind:class="'tenant-' + tenant">Features</h1>
        <div class="cont" v-html="item.features"></div>
        <h1 v-bind:class="'tenant-' + tenant">Location</h1>
        <div class="map">
          <div id="map"></div>
        </div>
      </div>
      <reverse
        :showCall="false"
        :showReserve="
          $route.query.publicFlag &&
            $route.query.publicFlag !== undefined &&
            $route.query.publicFlag !== null
        "
        @accept="reserve"
      ></reverse>
    </div>

    <van-image-preview v-model="show" :images="bigImgList" @change="onChange">
      <!--<template v-slot:index>第{{ index }}页</template>-->
    </van-image-preview>
  </div>
</template>

<script>
import reverse from "@/components/package/reserve";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapActions, mapState, mapMutations } from "vuex";

export default {
  data() {
    const self = this;
    return {
      loading: true,
      gray: true,
      initialSlide: 1,
      imgList: [],
      bigImgList: [],
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          loop: true
        },
        on: {
          slideChangeTransitionEnd: function() {
            self.initialSlide = this.activeIndex + 1;
          }
        }
      },
      active: 1,
      isConfirm: false,
      pop: false,
      later: {},
      // centers: {lat: -25.344, lng: 131.036},
      icon: require("../../../assets/location.png"),
      mode: "off",
      URL: "",
      show: false,
      index: 0,
      item: {},
      tenant: window.location.hostname
        .replace("m.", "")
        .split(".")[0]
        .split("testunifiproperty")[0]
        .split("unifiproperty")[0]
        .split("platform")[0]
    };
  },
  created() {
    var that = this;
    console.log(888);
    console.log(that.$route.params.id);
    if (!that.$route.params.id) {
      return;
    }
    console.log(545454);
    if (
      sessionStorage.getItem("psd") &&
      sessionStorage.getItem("psd") !== null &&
      sessionStorage.getItem("psd") !== undefined &&
      sessionStorage.getItem("psd").split("/")[1] == that.$route.params.id
    ) {
      that.$box.loadings();
      that.getPropertyDtl2({
        params: {
          id: that.$route.params.id,
          publicFlag: this.$route.query.publicFlag ? 1 : 0,
          password: sessionStorage.getItem("psd").split("/")[0]
        },
        callback: that.callback
      });
    }
  },
  mounted() {
    document.getElementById("top").scrollIntoView();
  },
  methods: {
    reserve() {
      var that = this;
      that.$router.push({
        path: `/private/selection/${that.$route.params.id}?publicFlag=${that.$route.query.publicFlag}&sessionId=${that.$route.query.sessionId}`
      });
    },
    initMap(lat, lng) {
      var options = {
        zoom: 16,
        center: new google.maps.LatLng(lat, lng),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        scaleControl: false,
        mapTypeControl: false
      };
      var map = new google.maps.Map(document.getElementById("map"), options);
      this.map = map;
      var places = [];
      places.push(new google.maps.LatLng(lat, lng));
      for (var i = 0; i < places.length; i++) {
        var marker = new google.maps.Marker({
          position: places[i],
          map: map,
          title: "Place number " + i
        });
      }
    },
    shwImg(url) {
      var that = this;
      that.show = true;
      that.index = 1;
      that.bigImgList = [];
      let lgt = that.imgList.length;
      for (let i = that.initialSlide - 1; i < lgt; i++) {
        that.bigImgList.push(that.imgList[i]);
      }
      if (that.initialSlide > 1) {
        let preList = [];
        for (let i = 0; i < that.initialSlide - 1; i++) {
          preList.push(that.imgList[i]);
        }
        that.bigImgList = that.bigImgList.concat(preList);
      }
    },
    onChange(index) {
      this.index = index + 1;
    },
    empty() {
      var that = this;
      that.$box.alert("", "No content yet.", "error");
    },
    ...mapActions("property", ["getPropertyDtl"]),
    ...mapMutations("property", ["setPropertyDtl"]),
    ...mapActions("property", ["getPropertyDtl2"]),
    ...mapActions("home", ["postCollect", "cancelCollect"]),
    ...mapMutations("login", ["change"]),
    callback(res) {
      var that = this;
      that.loading = false;
      that.$box.loadings(2);
      if (res.data.code == 0) {
        that.status = 0;
        var datum = res.data.data;
        if (datum.imageUrl.indexOf(",") !== -1) {
          datum.imgLst = datum.imageUrl.split(",");
        } else {
          datum.imgLst = [datum.imageUrl];
        }
        that.imgList = datum.imgLst;
        datum.rental = that.$box.formatSplit(datum.rental, true);
        datum.commision = that.$box.formatSplit(
          parseInt(datum.commission),
          true
        );
        datum.price = that.$box.formatSplit(datum.price, true);
        datum.maxRental =
          datum.maxRental !== 0
            ? that.$box.formatSplit(datum.maxRental, true)
            : null;
        datum.maxCommision =
          datum.maxCommision !== ""
            ? that.$box.formatSplit(parseInt(datum.maxCommision), true)
            : "";
        datum.maxPrice =
          datum.maxPrice !== ""
            ? that.$box.formatSplit(datum.maxPrice, true)
            : "";

        datum.landPrice =
          datum.landPrice !== ""
            ? that.$box.formatSplit(datum.landPrice, true)
            : "";
        datum.buildPrice =
          datum.buildPrice !== ""
            ? that.$box.formatSplit(datum.buildPrice, true)
            : "";
        // 设置地图经纬度
        (datum.lat = datum.latitude), (datum.lng = datum.longitude);
        this.initMap(datum.latitude, datum.longitude);
        // 8848
        // datum.informationPack = datum.informationPack.split('https://file.alfred.store')[1]
        that.item = datum;
        that.setPropertyDtl({ data: res.data.data });
      } else if (res.data.code === 400004) {
        that.changeStatus({ data: "delete" });
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    }
  },
  components: {
    swiper,
    swiperSlide,
    reverse
  },
  computed: {
    ...mapState({
      curMode: state => state.login.mode // 实时变化
    })
  },
  watch: {
    curMode(val) {
      this.mode = localStorage.getItem("mode");
    }
  }
};
</script>

<style lang="scss" scoped>
.out {
  padding-top: 2.2rem;
}

.bigWrp {
  width: 100%;
  margin-bottom: 0.48rem;
  position: relative;
  transition: all 0.5s;

  .swiper-wrap {
    width: 100%;
    height: 5rem;

    .img {
      width: 100%;
      height: 5rem;
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
      background-color: #3f3f46;
      cursor: pointer;
    }

    .c-wrap {
      position: absolute;
      left: 0;
      top: 3.8rem;
      width: 100%;
      z-index: 5;
    }

    .camera {
      width: 2rem;
      height: 0.68rem;
      z-index: 3;
      background-color: #3f3f46;
      border-radius: 0.12rem;
      background-repeat: no-repeat;
      background-position: -0.12rem center;
      background-size: contain;
      background-image: url("../../../assets/4.png");
      box-sizing: border-box;
      line-height: 0.68rem;
      font-size: 0.32rem;
      padding-left: 0.7rem;
      color: #fff;
      font-weight: normal;
      cursor: pointer;
      padding-right: 0.2rem;
      margin: 0 auto;
    }
  }

  .collect {
    position: absolute;
    top: 0;
    left: 0;
    width: 0.86rem;
    height: 0.92rem;
    background-position: center center;
    background-repeat: no-repeat;
    cursor: pointer;
    z-index: 2;
  }

  .notCollected {
    background-image: url("../../../assets/tag.png");
  }

  .collected {
    background-image: url("../../../assets/tag2.png");
  }
}

.con {
  width: 100%;
  box-sizing: border-box;
  padding: 0 0.24rem;
  margin-top: -0.3rem;
  z-index: 8;
  position: relative;

  .shadow {
    width: 100%;
    height: 0.3rem;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0.04rem 0.32rem 0px rgba(0, 0, 0, 0.08);
    border-top-left-radius: 0.04rem;
    border-top-right-radius: 0.04rem;
    z-index: 2;
  }
}

.txtWrp {
  width: 100%;
  box-sizing: border-box;
  padding: 0.3rem 0.16rem 0.16rem 0.16rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.04rem;
  border: 1px solid rgba(247, 247, 250, 1);
  border-top: none;
  overflow: hidden;
  transition: all 0.5s;
  z-index: 999999;

  h1 {
    color: #3f3f46;
    margin-bottom: 0.1rem;
    font-size: 0.32rem;
    text-align: right;
  }

  h2 {
    color: #979497;
    font-size: 0.24rem;
    line-height: 0.28rem;
    margin-bottom: 0.1rem;
  }

  h3 {
    font-size: 0.52rem;
    color: #3f3f46;
    line-height: 0.62rem;
    margin-bottom: 0.12rem;

    span {
      display: block;
      font-size: 0.4rem;
      color: #979497;
    }

    i {
      font-style: normal;
      margin-right: 0.3rem;
    }
  }

  .dtl {
    width: 100%;
    position: relative;
    padding: 0.06rem 0;
    margin-bottom: 0.22rem;

    p {
      font-size: 0.28rem;
      color: #979497;
      margin-bottom: 0.1rem;
      display: flex;
      flex-direction: row;

      span:nth-child(1) {
        flex: 0 0 auto;
        width: 3.2rem;
        text-align: right;
        vertical-align: top;
        margin-right: 0.35rem;
      }

      span:nth-child(2) {
        flex: 1;
        color: #3f3f46;
        display: inline-block;
        word-break: break-word;
      }
    }

    p:nth-last-child(1) {
      margin: 0;
    }
  }

  .dtl:after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 0.1rem;
    height: 2.3rem;
    //background:rgba(255,239,0,1);
  }

  .commision {
    height: 2.9rem;
    background: rgba(63, 63, 70, 1);
    border-radius: 0.04rem;
    box-sizing: border-box;
    padding: 0 0.16rem;
    color: #fff;
    margin-top: 0.6rem;

    h4 {
      font-size: 0.28rem;
      line-height: 1rem;
      border-bottom: 1px solid #fff;
      margin-bottom: 0.15rem;
      font-weight: normal;
      padding-top: 0.15rem;

      span {
        font-size: 0.4rem;
        float: right;
      }
    }

    .huan {
      font-size: 0.28rem;
      line-height: 0.5rem;
      border-bottom: 1px solid #fff;
      margin-bottom: 0.15rem;
      font-weight: normal;
      padding-top: 0.15rem;

      span {
        font-size: 0.4rem;
        display: block;
        float: none;
        line-height: 0.8rem;
      }
    }

    h5 {
      font-size: 0.28rem;
      text-align: center;
      line-height: 0.5rem;
      font-weight: normal;
    }
  }
}

.down-wrap {
  width: 100%;
  box-sizing: border-box;
  padding: 0 0.37rem;
}

.down {
  cursor: pointer;
  width: 100%;
  height: 0.92rem;
  background: rgba(44, 202, 115, 1);
  border-radius: 0.12rem;
  text-align: center;
  line-height: 0.92rem;
  font-size: 0.28rem;
  color: #fff;
  margin-bottom: 0.64rem;

  a {
    display: block;
    width: 100%;
    line-height: 0.92rem;
    text-decoration: none;
    color: #fff;
  }
}

.container {
  width: 100%;
  margin: 0 auto;
  background: rgba(245, 245, 247, 1);
  box-sizing: border-box;
  padding: 0.64rem 0.32rem 0.32rem 0.32rem;

  h1 {
    font-size: 0.48rem;
    color: #333333;
    position: relative;
    margin-bottom: 0.9rem;
  }

  h1:after {
    content: "";
    display: block;
    width: 1.16rem;
    height: 0.06rem;
    //background: #FFEF00;
    position: absolute;
    left: 0;
    bottom: -0.1rem;
  }

  p {
    margin-bottom: 0.8rem;
    font-size: 0.28rem;
    line-height: 0.42rem;
  }

  .cont {
    margin-bottom: 0.38rem;
  }

  .map {
    width: 100%;
    height: 3.82rem;
  }

  #map {
    width: 100%;
    height: 3.82rem;
  }
}

.swiper-button-prev {
  background-image: url("../../../assets/p.png");
  background-size: contain;
  background-repeat: no-repeat;
  width: 0.6rem;
  height: 0.6rem;
  left: 0.24rem;
}

.swiper-button-next {
  background-image: url("../../../assets/n.png");
  background-size: contain;
  background-repeat: no-repeat;
  width: 0.6rem;
  height: 0.6rem;
  right: 0.24rem;
}

.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.btn-enter-active,
.btn-leave-active {
  transition: opacity 0.5s;
}

.btn-enter,
.btn-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/private/property/property.vue